import { useLocation } from "react-router-dom";

import { useProduct, useQueryParam } from "~/hooks";

import { SignIn, StepOne, StepTwo, StepThree, StepFour, Activate, Talks } from "./components";

function Outdoor() {
  const { pathname } = useLocation();
  const params = useQueryParam("product");
  const product = useProduct();

  const productName = params.product || product.name.toLowerCase();

  const isTalks = productName === "talks";

  const match = (path: string) => pathname === path;

  if (match("/signin/")) return <SignIn />;

  if (match("/signup/") && isTalks) return <Talks />;

  if (match("/signup/")) return <StepOne />;

  if (match("/signup/validate-email/")) return <StepTwo />;

  if (match("/signup/validate-phone/")) return <StepThree />;

  if (match("/signup/profile/")) return <StepFour />;

  if (pathname.includes("/activate")) return <Activate />;

  return null;
}

export default Outdoor;
